/* eslint-disable @typescript-eslint/no-unused-vars */
import React from "react";
import BertCardWrapper from "../BertCardWrapper";
import { Handle, NodeProps, Position } from "reactflow";
import { Box, Popover, Stack, Typography } from "@mui/material";
import ConditionSvg from "../../svg/ConditionSvg";
import BertMoreOptionsSvg from "../../svg/BertMoreOptionsSvg";
import MultiResponseBlock from "./MultiResponseBlock";
import { MultipleResponseNode } from "../../../types/bert";
import HandlerWrapper from "../Handlers/HandlerWrapper";
import CreateMutiResponseBlockType from "./CreateMutiResponseBlockType";
import { isDefined } from "@convin/utils/helper/common.helper";
import useAnchorEl from "@convin/hooks/useAnchorEl";
import DeleteLegendSvg from "../../svg/DeleteLegendSvg";
import EditLegendSvg from "../../svg/EditLegendSvg";
import NodeStatePorvider from "../../context/NodeStatePorvider";
import CreateEditConditionalNode from "../CreateEditConditionalNode";
import { useReactFlowStateContextProvider } from "../../hooks/useReactFlowStateContextProvider";
import ResponseBlockSvg from "../../svg/ResponseBlockSvg";
import CreateEditResponseNode from "../CreateEditResponseNode";
import InfoLegendSvg from "../../svg/InfoLegendSvg";
import DialogButton from "@convin/components/custom_components/Button/DialogButton";
import { Label } from "@convin/components/custom_components/Typography/Label";
import { MultiResponseNodeType } from "../../context/NodeStateContext";
import { NodeInfoProvider } from "../../context/NodeInfoContext";
import GptConditionSvg from "../../svg/GptConditionSvg";
import { pxToRem } from "@convin/utils/getFontValue";
import useParameterAiConfigContext from "../../hooks/useParameterAiConfigContext";

export default function MultiResponseNode(
    props: NodeProps<MultipleResponseNode<MultiResponseNodeType>>
) {
    const { currentVersion } = useParameterAiConfigContext();
    const { deleteNode, nodes } = useReactFlowStateContextProvider();
    const { data, isConnectable, id, targetPosition } = props;
    const {
        open: toolBarOpen,
        handleClick: handleToolbarClick,
        handleClose: handleToolbarClose,
        anchorEl: toolbarAnchor,
    } = useAnchorEl<HTMLButtonElement | null>();
    const {
        open: editOpen,
        handleClick: handleEditClick,
        handleClose: handleEditClose,
        anchorEl: editAnchor,
    } = useAnchorEl<HTMLButtonElement | null>();
    const {
        open: infoOpen,
        handleClick: handleInfoClick,
        handleClose: handleInfoClose,
        anchorEl: infoAnchor,
    } = useAnchorEl<HTMLButtonElement | null>();

    const isResponseNode = data.type === "response";

    return (
        <NodeInfoProvider nodeType={data.type} id={id}>
            <>
                {isConnectable && isDefined(targetPosition) && (
                    <Handle
                        type={"target"}
                        id={`${id}`}
                        position={targetPosition}
                    />
                )}

                <div className="flex items-center justify-between w-full mb-[16px]">
                    <div className="flex items-center flex-1 overflow-hidden gap-[16px]">
                        {isResponseNode ? (
                            <svg
                                width="32"
                                height="32"
                                viewBox="0 0 32 32"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <rect
                                    x="1"
                                    y="1"
                                    width="30"
                                    height="30"
                                    rx="6"
                                    fill="#503C3C"
                                    stroke="#503C3C"
                                />
                                <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M10.2844 8H18.5573C19.1627 8.0014 19.743 8.24253 20.1711 8.67063C20.5992 9.09873 20.8403 9.67896 20.8417 10.2844V15.3778C20.8403 15.9832 20.5992 16.5634 20.1711 16.9915C19.743 17.4196 19.1627 17.6608 18.5573 17.6622H14.2316L10.7638 20.6438C10.708 20.6927 10.6392 20.7244 10.5658 20.7351C10.4924 20.7458 10.4174 20.7351 10.35 20.7043C10.2825 20.6734 10.2254 20.6237 10.1854 20.5611C10.1455 20.4986 10.1246 20.4258 10.125 20.3516C10.125 20.3423 10.125 20.3317 10.125 20.3224L10.3096 17.6568H10.2844C9.67988 17.6554 9.10045 17.4151 8.6725 16.9881C8.24455 16.5611 8.0028 15.9823 8 15.3778V10.2844C8.0014 9.67896 8.24253 9.09873 8.67063 8.67063C9.09873 8.24253 9.67896 8.0014 10.2844 8ZM14.0125 13.3856L12.4479 13.2395L14.051 10.0931H15.824L14.5078 12.0282L16.3168 12.2288L12.9964 16.2132L14.0071 13.3842L14.0125 13.3856ZM22.1831 11.7188C22.6936 11.8181 23.1538 12.0916 23.4852 12.4924C23.8165 12.8933 23.9985 13.3967 24 13.9168V19.0076C23.9989 19.6008 23.7628 20.1694 23.3434 20.5888C22.9239 21.0083 22.3553 21.2444 21.7621 21.2455H21.6798L21.8683 23.9615C21.869 23.9686 21.869 23.9757 21.8683 23.9827C21.8683 24.0722 21.8328 24.158 21.7695 24.2213C21.7063 24.2845 21.6205 24.3201 21.531 24.3201C21.4506 24.3204 21.3727 24.2916 21.3119 24.2391L17.8282 21.1578H13.2448L15.5026 18.8601H20.2839C20.7872 18.8587 21.2694 18.6582 21.6253 18.3023C21.9812 17.9464 22.1817 17.4642 22.1831 16.9609V11.7188ZM18.556 8.77032H10.2844C9.88315 8.77137 9.49865 8.93122 9.21494 9.21494C8.93122 9.49865 8.77137 9.88315 8.77032 10.2844V15.3778C8.76996 15.78 8.92915 16.166 9.21298 16.4511C9.49681 16.7362 9.88211 16.8971 10.2844 16.8985H10.7532C10.8506 16.9055 10.9417 16.9492 11.0082 17.0206C11.0747 17.092 11.1117 17.186 11.1118 17.2836C11.1118 17.2916 11.1118 17.2996 11.1118 17.3075L10.9604 19.4631L13.8212 17.0034C13.8918 16.933 13.9871 16.893 14.0868 16.8918H18.556C18.9572 16.8908 19.3417 16.7309 19.6254 16.4472C19.9092 16.1635 20.069 15.779 20.0701 15.3778V10.2844C20.069 9.88315 19.9092 9.49865 19.6254 9.21494C19.3417 8.93122 18.9572 8.77137 18.556 8.77032Z"
                                    fill="white"
                                />
                            </svg>
                        ) : data.type === "condition_gpt" ? (
                            <GptConditionSvg
                                sx={{
                                    backgroundColor: "#8741f9",
                                    color: "#fff",
                                    borderRadius: "4px",
                                }}
                            />
                        ) : (
                            <svg
                                width="32"
                                height="32"
                                viewBox="0 0 32 32"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <rect
                                    x="1"
                                    y="1"
                                    width="30"
                                    height="30"
                                    rx="6"
                                    fill="#8741F9"
                                    stroke="#8741F9"
                                />
                                <g mask="url(#mask0_1185_40632)">
                                    <path
                                        d="M17.668 22.6693V21.0026H20.168C20.4041 21.0026 20.602 20.9227 20.7617 20.763C20.9214 20.6033 21.0013 20.4054 21.0013 20.1693V18.5026C21.0013 17.9748 21.1541 17.4957 21.4596 17.0651C21.7652 16.6345 22.168 16.329 22.668 16.1484V15.8568C22.168 15.6762 21.7652 15.3707 21.4596 14.9401C21.1541 14.5095 21.0013 14.0304 21.0013 13.5026V11.8359C21.0013 11.5998 20.9214 11.4019 20.7617 11.2422C20.602 11.0825 20.4041 11.0026 20.168 11.0026H17.668V9.33594H20.168C20.8624 9.33594 21.4527 9.57899 21.9388 10.0651C22.4249 10.5512 22.668 11.1415 22.668 11.8359V13.5026C22.668 13.7387 22.7478 13.9366 22.9076 14.0964C23.0673 14.2561 23.2652 14.3359 23.5013 14.3359H24.3346V17.6693H23.5013C23.2652 17.6693 23.0673 17.7491 22.9076 17.9089C22.7478 18.0686 22.668 18.2665 22.668 18.5026V20.1693C22.668 20.8637 22.4249 21.454 21.9388 21.9401C21.4527 22.4262 20.8624 22.6693 20.168 22.6693H17.668ZM11.8346 22.6693C11.1402 22.6693 10.5499 22.4262 10.0638 21.9401C9.57769 21.454 9.33464 20.8637 9.33464 20.1693V18.5026C9.33464 18.2665 9.25477 18.0686 9.09505 17.9089C8.93533 17.7491 8.73741 17.6693 8.5013 17.6693H7.66797V14.3359H8.5013C8.73741 14.3359 8.93533 14.2561 9.09505 14.0964C9.25477 13.9366 9.33464 13.7387 9.33464 13.5026V11.8359C9.33464 11.1415 9.57769 10.5512 10.0638 10.0651C10.5499 9.57899 11.1402 9.33594 11.8346 9.33594H14.3346V11.0026H11.8346C11.5985 11.0026 11.4006 11.0825 11.2409 11.2422C11.0812 11.4019 11.0013 11.5998 11.0013 11.8359V13.5026C11.0013 14.0304 10.8485 14.5095 10.543 14.9401C10.2374 15.3707 9.83464 15.6762 9.33464 15.8568V16.1484C9.83464 16.329 10.2374 16.6345 10.543 17.0651C10.8485 17.4957 11.0013 17.9748 11.0013 18.5026V20.1693C11.0013 20.4054 11.0812 20.6033 11.2409 20.763C11.4006 20.9227 11.5985 21.0026 11.8346 21.0026H14.3346V22.6693H11.8346Z"
                                        fill="white"
                                    />
                                </g>
                            </svg>
                        )}

                        <div className="flex flex-col overflow-hidden flex-1 uppercase text-[#999] text-[12px]">
                            {isResponseNode
                                ? "Response"
                                : data.type === "condition_gpt"
                                ? "GPT CONDITION"
                                : "Condition"}

                            <span className="font-semibold w-full text-ellipsis overflow-hidden whitespace-nowrap text-[16px] text-[#333] capitalize">
                                {data.metadata.name}
                            </span>
                        </div>
                    </div>
                    {!isDefined(currentVersion) && (
                        <button
                            onClick={handleToolbarClick}
                            className="flex-shrink-0 font-semibold scale-[1.4]"
                        >
                            &#8942;
                        </button>
                    )}
                </div>
                {data.metadata.blocks.map((block, idx) => {
                    return (
                        <HandlerWrapper
                            AddComponent={CreateMutiResponseBlockType}
                            {...props}
                            sourcePosition={block.sourcePosition ?? undefined}
                            blockId={block.id}
                            key={block.sourcePosition ? block.id : idx}
                            hideSourceHandles={
                                isResponseNode
                                    ? true
                                    : !isDefined(block.data.type)
                            }
                        >
                            <MultiResponseBlock
                                key={block.id}
                                {...block}
                                parent={id}
                                isConditionBlock={!isResponseNode}
                                hideNot={
                                    data.type === "condition_gpt" ? true : false
                                }
                            />
                        </HandlerWrapper>
                    );
                })}

                <Popover
                    anchorEl={toolbarAnchor}
                    open={toolBarOpen}
                    onClose={handleToolbarClose}
                    transformOrigin={{ horizontal: -10, vertical: "center" }}
                    anchorOrigin={{ horizontal: "right", vertical: "center" }}
                    slotProps={{
                        paper: {
                            sx: {
                                bgcolor: "transparent",
                                border: "none",
                            },
                        },
                    }}
                >
                    <Box className="flex flex-col items-center" gap={1}>
                        <button onClick={handleInfoClick}>
                            <InfoLegendSvg />
                        </button>
                        <button onClick={handleEditClick}>
                            <EditLegendSvg />
                        </button>
                        {isConnectable ||
                        (!isConnectable && nodes.length === 1) ? (
                            <DialogButton
                                onDelete={() => {
                                    return new Promise(() => {
                                        deleteNode(id);
                                        handleToolbarClose();
                                    });
                                }}
                                title="Delete Node"
                                message="Are you sure you want to delete this Node?"
                                DeleteOptionComponent={
                                    <button>
                                        <DeleteLegendSvg />
                                    </button>
                                }
                            />
                        ) : (
                            <></>
                        )}
                    </Box>
                </Popover>
                <Popover
                    open={editOpen || infoOpen}
                    anchorEl={editAnchor || infoAnchor}
                    // onClose={editOpen ? handleEditClose : handleInfoClose}
                    anchorOrigin={{
                        vertical: "center",
                        horizontal: "center",
                    }}
                    transformOrigin={{
                        vertical: "top",
                        horizontal: "left",
                    }}
                >
                    <NodeStatePorvider
                        onNodeSaveCallBack={() => {
                            handleEditClose();
                            handleToolbarClose();
                        }}
                        nodeIdToUpdate={id}
                        nodeDataToUpdate={props.data.metadata}
                    >
                        <BertCardWrapper
                            className="w-[400px]"
                            sx={{
                                ...((infoOpen || !editOpen) && {
                                    "& button": {
                                        display: "none",
                                    },

                                    "& .node_content": {
                                        userSelect: "none",
                                        pointerEvents: "none",
                                    },
                                }),
                            }}
                            onClick={(e) => {
                                const target = e.target as HTMLElement;
                                if (
                                    target &&
                                    target.classList.contains(
                                        "block_close_button"
                                    )
                                ) {
                                    if (editOpen) {
                                        handleEditClose();
                                    } else {
                                        handleInfoClose();
                                    }
                                }
                            }}
                        >
                            {isResponseNode ? (
                                <CreateEditResponseNode />
                            ) : (
                                <CreateEditConditionalNode
                                    type={
                                        data.type as Exclude<
                                            MultiResponseNodeType,
                                            "response"
                                        >
                                    }
                                />
                            )}
                        </BertCardWrapper>
                    </NodeStatePorvider>
                </Popover>
            </>
        </NodeInfoProvider>
    );
}
